import { IMergeMenuItem } from '@/editor/types';
import { EMergeKey, EMergeLabel } from '@/editor/types/enums';

export const documentTags: IMergeMenuItem[] = [
  {
    label: EMergeLabel.Name,
    value: EMergeKey.name,
  },
  {
    label: EMergeLabel.Value,
    value: EMergeKey.value,
  },
  {
    label: EMergeLabel.SendDate,
    value: EMergeKey.sendDate,
  },
  {
    label: EMergeLabel.UniqueId,
    value: EMergeKey.uniqueId,
  },
  {
    label: EMergeLabel.ExpirationDate,
    value: EMergeKey.expirationDate,
  },
];

export const recipientTags: IMergeMenuItem[] = [
  {
    label: EMergeLabel.FirstName,
    value: EMergeKey.firstName,
  },
  {
    label: EMergeLabel.LastName,
    value: EMergeKey.lastName,
  },
  {
    label: EMergeLabel.Title,
    value: EMergeKey.title,
  },
  {
    label: EMergeLabel.Email,
    value: EMergeKey.email,
  },
  {
    label: EMergeLabel.Mobile,
    value: EMergeKey.mobile,
  },
  {
    label: EMergeLabel.CompanyName,
    value: EMergeKey.companyName,
  },
  {
    label: EMergeLabel.OrganisationNumber,
    value: EMergeKey.companyNumber,
  },
];

export const senderTags: IMergeMenuItem[] = [
  {
    label: EMergeLabel.FirstName,
    value: EMergeKey.firstName,
  },
  {
    label: EMergeLabel.LastName,
    value: EMergeKey.lastName,
  },
  {
    label: EMergeLabel.Title,
    value: EMergeKey.title,
  },
  {
    label: EMergeLabel.Email,
    value: EMergeKey.email,
  },
  {
    label: EMergeLabel.Mobile,
    value: EMergeKey.mobile,
  },
];

export const entityTags: IMergeMenuItem[] = [
  {
    label: EMergeLabel.EntityName,
    value: EMergeKey.name,
  },
  {
    label: EMergeLabel.Address,
    value: EMergeKey.address,
  },
  {
    label: EMergeLabel.Zip,
    value: EMergeKey.zip,
  },
  {
    label: EMergeLabel.State,
    value: EMergeKey.state,
  },
  {
    label: EMergeLabel.City,
    value: EMergeKey.city,
  },
  {
    label: EMergeLabel.Country,
    value: EMergeKey.country,
  },
  {
    label: EMergeLabel.RegisteredNumber,
    value: EMergeKey.registeredNumber,
  },
  {
    label: EMergeLabel.Website,
    value: EMergeKey.website,
  },
  {
    label: EMergeLabel.Email,
    value: EMergeKey.email,
  },
];
